const resolutionStore = [
  "320x180",
  "640x360",
  "960x540",
  "1280x720",
  "1920x1080"
]

export default resolutionStore;